import React, { useState } from 'react';
import {
  IconApps,
  IconChevronDown,
  IconDeviceDesktopAnalytics,
  IconHome2,
  IconUser,
  IconShoppingCart,
  IconArchive,
  IconReceipt2,
  IconBuildingStore,
  IconChartBar,
  IconWallet,
  IconDiamond,
  IconSettings,
  IconLogout,
  IconMenu2,
  IconX,
  IconClipboardList,
  IconBox,
  IconTags,
  IconShoppingCartOff,
  IconSun,
  IconMoon,
} from '@tabler/icons-react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import AddJenisBarang from '../components/Admin/AddJenisBarang';
import { useTheme } from '../context/ThemeContext';
import logoKD from '../assets/logo_kd.png';

const Navbar = () => {
  const navigate = useNavigate();
  const { theme, toggleTheme } = useTheme();

  const [openMobile, setMobileOpen] = useState(false);
  const [openMasterMobile, setOpenMasterMobile] = useState(false);
  const [openTransaksiMobile, setOpenTransaksiMobile] = useState(false);

  // ─── STYLING ───
  const activeNav = 'border-b-2 lg:flex items-center py-2 lg:py-3 border-amber-500 text-black font-bold dark:text-amber-400 dark:font-semibold transition-colors';
  const normalLink = 'block py-2 lg:py-3 align-middle lg:flex items-center text-black font-bold dark:text-slate-300 hover:text-amber-600 dark:hover:text-amber-400 transition-colors border-b-2 border-transparent hover:border-amber-400';

  function logout() {
    localStorage.removeItem('role');
    localStorage.removeItem('token');
    localStorage.removeItem('name');
    navigate('/login');
  }

  const check = localStorage.getItem('role');
  const user = localStorage.getItem('name');

  let [isOpen, setIsOpen] = useState(false);

  function closeModal() {
    setIsOpen(false);
  }
  function openModal() {
    setIsOpen(true);
  }

  return (
    <nav className="fixed top-0 w-full z-50 shadow-[0_4px_20px_-10px_rgba(0,0,0,0.1)] dark:shadow-[0_4px_20px_-10px_rgba(0,0,0,0.4)] border-b border-amber-300/60 dark:border-amber-700/50 transition-colors duration-300">
      <div className="absolute inset-0 bg-gradient-to-r from-yellow-200/95 via-amber-100/95 to-yellow-200/95 dark:from-amber-900/40 dark:via-slate-900 dark:to-amber-900/40 backdrop-blur-md pointer-events-none -z-10" />
      <AddJenisBarang isOpen={isOpen} closeModal={closeModal} />
      <div className="w-full container mx-auto flex flex-wrap items-center mt-0 pt-3 pb-3 lg:pb-0 px-4">

        {/* Brand Logo */}
        <div className="w-1/2">
          <Link to="/" className="flex items-center gap-3 hover:opacity-80 transition-opacity">
            <div className="flex items-center justify-center w-9 h-9 sm:w-10 sm:h-10 rounded-xl bg-gradient-to-br from-amber-400 to-amber-600 text-white shadow-md">
              {/* <IconDiamond size={24} stroke={2} fill="currentColor" className="opacity-95" /> */}
              <img src={logoKD} alt="Komala Dewi" className="w-full h-full object-cover" />
            </div>
            <span className="text-xl sm:text-2xl font-extrabold tracking-wide bg-clip-text text-transparent bg-gradient-to-r from-amber-600 to-amber-800 dark:from-amber-400 dark:to-amber-500">
              Komala Dewi
            </span>
          </Link>
        </div>

        {/* User Profile & Mobile Toggle */}
        <div className="w-1/2 flex justify-end items-center">
          {/* Theme toggle */}
          <button
            onClick={toggleTheme}
            className="p-2 rounded-lg text-slate-500 dark:text-slate-400 hover:text-amber-600 dark:hover:text-amber-400 hover:bg-amber-50 dark:hover:bg-slate-800 transition-colors mr-1"
            title={theme === 'light' ? 'Dark Mode' : 'Light Mode'}
          >
            {theme === 'light' ? <IconMoon size={20} /> : <IconSun size={20} />}
          </button>

          <div className="relative text-sm">
            <div className="dropdown dropdown-end">
              <label tabIndex={0} className="cursor-pointer flex items-center gap-2 group p-1.5 rounded-lg hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors">
                <div className="w-8 h-8 rounded-full bg-amber-100 dark:bg-amber-900/40 text-amber-700 dark:text-amber-400 flex items-center justify-center font-bold shadow-inner border border-amber-200 dark:border-amber-700/50">
                  {user ? user.charAt(0).toUpperCase() : 'U'}
                </div>
                <div className="font-semibold text-slate-700 dark:text-slate-300 group-hover:text-amber-600 dark:group-hover:text-amber-400 transition-colors hidden sm:block">
                  {user}
                </div>
                <IconChevronDown size={16} className="text-slate-400 dark:text-slate-500 group-hover:text-amber-500 transition-colors" />
              </label>
              <div tabIndex={0} className="dropdown-content menu p-2 mt-2 shadow-lg bg-white dark:bg-slate-800 rounded-xl w-52 border border-slate-100 dark:border-slate-700">
                <div className="px-4 py-3 border-b border-slate-100 dark:border-slate-700 mb-1">
                  <p className="text-sm font-semibold text-slate-800 dark:text-slate-200 truncate">{user}</p>
                  <p className="text-xs text-slate-500 dark:text-slate-400 capitalize">{check}</p>
                </div>
                <button
                  onClick={logout}
                  className="w-full text-left py-2.5 px-3 flex items-center gap-2 text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20 hover:text-red-700 dark:hover:text-red-300 rounded-lg transition-colors font-medium text-sm"
                >
                  <IconLogout size={18} />
                  Log out
                </button>
              </div>
            </div>
          </div>

          {/* Mobile Menu Button */}
          <div className="block lg:hidden ml-4">
            <button
              onClick={() => setMobileOpen(!openMobile)}
              className="flex items-center justify-center p-2 rounded-xl text-slate-500 dark:text-slate-400 hover:text-amber-600 dark:hover:text-amber-400 hover:bg-amber-50 dark:hover:bg-slate-800 transition-all border border-transparent active:scale-90 active:bg-amber-100 dark:active:bg-slate-700"
              aria-label="Toggle menu"
            >
              <div className={`transition-transform duration-300 ${openMobile ? 'rotate-90' : 'rotate-0'}`}>
                {openMobile ? <IconX size={26} stroke={2.5} /> : <IconMenu2 size={26} stroke={2.5} />}
              </div>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      <div
        className={`fixed inset-0 bg-slate-900/60 backdrop-blur-sm z-[100] transition-opacity lg:hidden ${openMobile ? 'opacity-100 visible' : 'opacity-0 invisible'}`}
        onClick={() => setMobileOpen(false)}
      />

      {/* Mobile Menu Drawer */}
      <div
        className={`fixed top-0 left-0 bottom-0 w-[280px] bg-white dark:bg-slate-900 z-[110] transform transition-transform duration-300 lg:hidden shadow-2xl border-r border-slate-200 dark:border-slate-800 overflow-y-auto ${openMobile ? 'translate-x-0' : '-translate-x-full'}`}
      >
        <div className="flex flex-col h-full">
          {/* Header in Drawer */}
          <div className="p-4 border-b border-slate-100 dark:border-slate-800 flex items-center justify-between">
            <Link to="/" onClick={() => setMobileOpen(false)} className="flex items-center group">
              <div className="w-8 h-8 rounded bg-gradient-to-br from-amber-400 to-amber-600 text-white flex items-center justify-center mr-2 shadow-sm transition-transform group-hover:scale-105">
                {/* <IconDiamond size={18} stroke={2.5} fill="currentColor" /> */}
                <img src={logoKD} alt="Komala Dewi" className="w-full h-full object-cover" />
              </div>
              <span className="font-bold bg-clip-text text-transparent bg-gradient-to-r from-amber-600 to-amber-800 dark:from-amber-400 dark:to-amber-500 text-lg">
                Komala Dewi
              </span>
            </Link>
            <button onClick={() => setMobileOpen(false)} className="p-2 text-slate-400 hover:text-red-500 transition-colors">
              <IconX size={20} />
            </button>
          </div>

          {/* Navigation Links in Drawer */}
          <div className="flex-1 p-4 space-y-1">
            <NavLink
              to="/"
              onClick={() => setMobileOpen(false)}
              className={({ isActive }) => `flex items-center gap-3 px-4 py-3 rounded-xl transition-all ${isActive ? 'bg-amber-50 dark:bg-amber-900/20 text-amber-600 dark:text-amber-400 font-bold shadow-sm' : 'text-slate-600 dark:text-slate-400 hover:bg-slate-50 dark:hover:bg-slate-800'}`}
            >
              <IconHome2 size={20} />
              <span>Dashboard</span>
            </NavLink>

            {check !== 'admin' && check !== 'operator' && (
              <>
                <NavLink to="/penjualan" onClick={() => setMobileOpen(false)} className={({ isActive }) => `flex items-center gap-3 px-4 py-3 rounded-xl transition-all ${isActive ? 'bg-amber-50 dark:bg-amber-900/20 text-amber-600 dark:text-amber-400 font-bold' : 'text-slate-600 dark:text-slate-400 hover:bg-slate-50 dark:hover:bg-slate-800'}`}>
                  <IconShoppingCart size={20} />
                  <span>Kasir Penjualan</span>
                </NavLink>
                <NavLink to="/transaksi-tertunda" onClick={() => setMobileOpen(false)} className={({ isActive }) => `flex items-center gap-3 px-4 py-3 rounded-xl transition-all ${isActive ? 'bg-amber-50 dark:bg-amber-900/20 text-amber-600 dark:text-amber-400 font-bold' : 'text-slate-600 dark:text-slate-400 hover:bg-slate-50 dark:hover:bg-slate-800'}`}>
                  <IconClipboardList size={20} />
                  <span>Kasir Penggarus</span>
                </NavLink>
                <NavLink to="/pembelian" onClick={() => setMobileOpen(false)} className={({ isActive }) => `flex items-center gap-3 px-4 py-3 rounded-xl transition-all ${isActive ? 'bg-amber-50 dark:bg-amber-900/20 text-amber-600 dark:text-amber-400 font-bold' : 'text-slate-600 dark:text-slate-400 hover:bg-slate-50 dark:hover:bg-slate-800'}`}>
                  <IconShoppingCart size={20} />
                  <span>Kasir Pembelian</span>
                </NavLink>
                <NavLink to="/pengembalian" onClick={() => setMobileOpen(false)} className={({ isActive }) => `flex items-center gap-3 px-4 py-3 rounded-xl transition-all ${isActive ? 'bg-amber-50 dark:bg-amber-900/20 text-amber-600 dark:text-amber-400 font-bold' : 'text-slate-600 dark:text-slate-400 hover:bg-slate-50 dark:hover:bg-slate-800'}`}>
                  <IconShoppingCartOff size={20} />
                  <span>Pengembalian</span>
                </NavLink>
                <NavLink to="/laporan-cashflow" onClick={() => setMobileOpen(false)} className={({ isActive }) => `flex items-center gap-3 px-4 py-3 rounded-xl transition-all ${isActive ? 'bg-amber-50 dark:bg-amber-900/20 text-amber-600 dark:text-amber-400 font-bold' : 'text-slate-600 dark:text-slate-400 hover:bg-slate-50 dark:hover:bg-slate-800'}`}>
                  <IconChartBar size={20} />
                  <span>Laporan</span>
                </NavLink>
              </>
            )}

            {check !== 'kasir' && check !== 'operator' && (
              <>
                {/* Master Barang Accordion */}
                <div className="space-y-1">
                  <button
                    onClick={() => setOpenMasterMobile(!openMasterMobile)}
                    className={`w-full flex items-center justify-between px-4 py-3 rounded-xl transition-all ${openMasterMobile ? 'bg-slate-50 dark:bg-slate-800' : 'text-slate-600 dark:text-slate-400 hover:bg-slate-50 dark:hover:bg-slate-800'}`}
                  >
                    <div className="flex items-center gap-3">
                      <IconBuildingStore size={20} />
                      <span>Master Barang</span>
                    </div>
                    <IconChevronDown size={16} className={`transition-transform duration-200 ${openMasterMobile ? 'rotate-180' : ''}`} />
                  </button>
                  <div className={`overflow-hidden transition-all duration-300 ${openMasterMobile ? 'max-h-60 opacity-100' : 'max-h-0 opacity-0'}`}>
                    <div className="pl-11 pr-4 space-y-1 py-1">
                      <button onClick={() => { openModal(); setMobileOpen(false); }} className="w-full text-left px-3 py-2 text-slate-500 hover:text-amber-600 text-sm flex items-center gap-2">
                        <IconTags size={16} /> Jenis Barang
                      </button>
                      <Link to="/list-items-admin" onClick={() => setMobileOpen(false)} className="w-full text-left px-3 py-2 text-slate-500 hover:text-amber-600 text-sm flex items-center gap-2">
                        <IconBox size={16} /> Stok Barang
                      </Link>
                      <Link to="/barang-opname" onClick={() => setMobileOpen(false)} className="w-full text-left px-3 py-2 text-slate-500 hover:text-amber-600 text-sm flex items-center gap-2">
                        <IconArchive size={16} /> Stok Opname
                      </Link>
                    </div>
                  </div>
                </div>

                {/* Transaksi Accordion */}
                <div className="space-y-1">
                  <button
                    onClick={() => setOpenTransaksiMobile(!openTransaksiMobile)}
                    className={`w-full flex items-center justify-between px-4 py-3 rounded-xl transition-all ${openTransaksiMobile ? 'bg-slate-50 dark:bg-slate-800' : 'text-slate-600 dark:text-slate-400 hover:bg-slate-50 dark:hover:bg-slate-800'}`}
                  >
                    <div className="flex items-center gap-3">
                      <IconReceipt2 size={20} />
                      <span>Transaksi</span>
                    </div>
                    <IconChevronDown size={16} className={`transition-transform duration-200 ${openTransaksiMobile ? 'rotate-180' : ''}`} />
                  </button>
                  <div className={`overflow-hidden transition-all duration-300 ${openTransaksiMobile ? 'max-h-60 opacity-100' : 'max-h-0 opacity-0'}`}>
                    <div className="pl-11 pr-4 space-y-1 py-1">
                      <Link to="/transaksi-penjualan" onClick={() => setMobileOpen(false)} className="w-full text-left px-3 py-2 text-slate-500 hover:text-amber-600 text-sm">Penjualan</Link>
                      <Link to="/transaksi-pembelian" onClick={() => setMobileOpen(false)} className="w-full text-left px-3 py-2 text-slate-500 hover:text-amber-600 text-sm">Pembelian</Link>
                      <Link to="/summary" onClick={() => setMobileOpen(false)} className="w-full text-left px-3 py-2 text-slate-500 hover:text-amber-600 text-sm">Laporan Ringkasan</Link>
                    </div>
                  </div>
                </div>

                <NavLink to="/list-users" onClick={() => setMobileOpen(false)} className={({ isActive }) => `flex items-center gap-3 px-4 py-3 rounded-xl transition-all ${isActive ? 'bg-amber-50 dark:bg-amber-900/20 text-amber-600 dark:text-amber-400 font-bold' : 'text-slate-600 dark:text-slate-400 hover:bg-slate-50 dark:hover:bg-slate-800'}`}>
                  <IconUser size={20} />
                  <span>Users</span>
                </NavLink>
              </>
            )}

            {check !== 'kasir' && check !== 'operator' && (
              <NavLink to="/saldo-kas" onClick={() => setMobileOpen(false)} className={({ isActive }) => `flex items-center gap-3 px-4 py-3 rounded-xl transition-all ${isActive ? 'bg-amber-50 dark:bg-amber-900/20 text-amber-600 dark:text-amber-400 font-bold' : 'text-slate-600 dark:text-slate-400 hover:bg-slate-50 dark:hover:bg-slate-800'}`}>
                <IconWallet size={20} />
                <span>Saldo KAS</span>
              </NavLink>
            )}

            {check !== 'kasir' && (
              <NavLink to="/tambah-barang" onClick={() => setMobileOpen(false)} className={({ isActive }) => `flex items-center gap-3 px-4 py-3 rounded-xl transition-all ${isActive ? 'bg-amber-50 dark:bg-amber-900/20 text-amber-600 dark:text-amber-400 font-bold' : 'text-slate-600 dark:text-slate-400 hover:bg-slate-50 dark:hover:bg-slate-800'}`}>
                <IconDiamond size={20} />
                <span>Tambah Barang</span>
              </NavLink>
            )}
          </div>

          {/* Bottom Profile in Drawer */}
          <div className="p-4 border-t border-slate-100 dark:border-slate-800 mt-auto bg-slate-50 dark:bg-slate-800/50">
            <div className="flex items-center gap-3 mb-4 px-2">
              <div className="w-10 h-10 rounded-full bg-amber-400 text-white flex items-center justify-center font-bold">
                {user ? user.charAt(0).toUpperCase() : 'U'}
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-bold text-slate-900 dark:text-white truncate">{user}</p>
                <p className="text-xs text-slate-500 capitalize">{check}</p>
              </div>
            </div>
            <button onClick={logout} className="w-full flex items-center justify-center gap-2 py-3 bg-red-50 dark:bg-red-900/20 text-red-600 dark:text-red-400 font-bold rounded-xl active:scale-95 transition-all text-sm">
              <IconLogout size={18} />
              Keluar Aplikasi
            </button>
          </div>
        </div>
      </div>

      {/* Desktop Navigation Menu */}
      <div
        className={`hidden lg:flex lg:items-center w-full container mx-auto px-4 mt-2 bg-transparent pb-0 transition-colors`}
      >
        <div className="lg:flex flex-wrap flex-1 items-center gap-x-6 gap-y-2 text-sm">

          {/* Dashboard */}
          <div className="my-1 lg:my-0">
            <NavLink to="/" className={({ isActive }) => (isActive ? activeNav : normalLink)}>
              <div className="flex items-center">
                <IconHome2 size={20} className="mr-2" />
                <span className="whitespace-nowrap">Dashboard</span>
              </div>
            </NavLink>
          </div>

          {/* Operator/Admin specific menus */}
          {check !== 'admin' && check !== 'operator' && (
            <>
              <div className="my-1 lg:my-0">
                <NavLink to="/penjualan" className={({ isActive }) => (isActive ? activeNav : normalLink)}>
                  <div className="flex items-center">
                    <IconShoppingCart size={20} className="mr-2" />
                    <span className="whitespace-nowrap">Kasir Penjualan</span>
                  </div>
                </NavLink>
              </div>
              <div className="my-1 lg:my-0">
                <NavLink to="/transaksi-tertunda" className={({ isActive }) => (isActive ? activeNav : normalLink)}>
                  <div className="flex items-center">
                    <IconClipboardList size={20} className="mr-2" />
                    <span className="whitespace-nowrap">Kasir Penggarus</span>
                  </div>
                </NavLink>
              </div>
              <div className="my-1 lg:my-0">
                <NavLink to="/pembelian" className={({ isActive }) => (isActive ? activeNav : normalLink)}>
                  <div className="flex items-center">
                    <IconShoppingCart size={20} className="mr-2" />
                    <span className="whitespace-nowrap">Kasir Pembelian</span>
                  </div>
                </NavLink>
              </div>
              <div className="my-1 lg:my-0">
                <NavLink to="/pengembalian" className={({ isActive }) => (isActive ? activeNav : normalLink)}>
                  <div className="flex items-center">
                    <IconShoppingCartOff size={20} className="mr-2" />
                    <span className="whitespace-nowrap">Pengembalian</span>
                  </div>
                </NavLink>
              </div>
              <div className="my-1 lg:my-0">
                <NavLink to="/laporan-cashflow" className={({ isActive }) => (isActive ? activeNav : normalLink)}>
                  <div className="flex items-center">
                    <IconChartBar size={20} className="mr-2" />
                    <span className="whitespace-nowrap">Laporan</span>
                  </div>
                </NavLink>
              </div>
            </>
          )}

          {/* Admin only menus */}
          {check !== 'kasir' && check !== 'operator' && (
            <>
              <div className="my-1 lg:my-0">
                <div className="dropdown dropdown-bottom lg:dropdown-hover w-full lg:w-auto">
                  <label
                    tabIndex={0}
                    className="block py-2 lg:py-3 align-middle cursor-pointer lg:flex items-center text-black font-bold dark:text-slate-300 hover:text-amber-600 dark:hover:text-amber-400 transition-colors border-b-2 border-transparent hover:border-amber-400"
                  >
                    <div className="flex items-center justify-between w-full lg:w-auto">
                      <div className="flex items-center">
                        <IconBuildingStore size={20} className="mr-2" />
                        <span className="whitespace-nowrap">Master Barang</span>
                      </div>
                      <IconChevronDown size={16} className="ml-1" />
                    </div>
                  </label>
                  <ul tabIndex={0} className="dropdown-content menu p-2 shadow-lg bg-white dark:bg-slate-800 rounded-xl w-full lg:w-52 border border-slate-100 dark:border-slate-700 z-[60]">
                    <li>
                      <button onClick={openModal} className="hover:bg-amber-50 dark:hover:bg-amber-900/20 hover:text-amber-700 dark:hover:text-amber-400 dark:text-slate-200 py-2.5">
                        <IconTags size={18} className="mr-2" />
                        Jenis Barang
                      </button>
                    </li>
                    <li>
                      <Link to="/list-items-admin" className="hover:bg-amber-50 dark:hover:bg-amber-900/20 hover:text-amber-700 dark:hover:text-amber-400 dark:text-slate-200 py-2.5">
                        <IconBox size={18} className="mr-2" />
                        Stok Barang
                      </Link>
                    </li>
                    <li>
                      <Link to="/barang-opname" className="hover:bg-amber-50 dark:hover:bg-amber-900/20 hover:text-amber-700 dark:hover:text-amber-400 dark:text-slate-200 py-2.5">
                        <IconArchive size={18} className="mr-2" />
                        Stok Opname
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="my-1 lg:my-0">
                <div className="dropdown dropdown-bottom lg:dropdown-hover w-full lg:w-auto">
                  <label
                    tabIndex={0}
                    className="block py-2 lg:py-3 align-middle cursor-pointer lg:flex items-center text-black font-bold dark:text-slate-300 hover:text-amber-600 dark:hover:text-amber-400 transition-colors border-b-2 border-transparent hover:border-amber-400"
                  >
                    <div className="flex items-center justify-between w-full lg:w-auto">
                      <div className="flex items-center">
                        <IconReceipt2 size={20} className="mr-2" />
                        <span className="whitespace-nowrap">Transaksi</span>
                      </div>
                      <IconChevronDown size={16} className="ml-1" />
                    </div>
                  </label>
                  <ul tabIndex={0} className="dropdown-content menu p-2 shadow-lg bg-white dark:bg-slate-800 rounded-xl w-full lg:w-52 border border-slate-100 dark:border-slate-700 z-[60]">
                    <li>
                      <Link to="/transaksi-penjualan" className="hover:bg-amber-50 dark:hover:bg-amber-900/20 hover:text-amber-700 dark:hover:text-amber-400 dark:text-slate-200 py-2.5">
                        Penjualan
                      </Link>
                    </li>
                    <li>
                      <Link to="/transaksi-pembelian" className="hover:bg-amber-50 dark:hover:bg-amber-900/20 hover:text-amber-700 dark:hover:text-amber-400 dark:text-slate-200 py-2.5">
                        Pembelian
                      </Link>
                    </li>
                    <li>
                      <Link to="/summary" className="hover:bg-amber-50 dark:hover:bg-amber-900/20 hover:text-amber-700 dark:hover:text-amber-400 dark:text-slate-200 py-2.5">
                        Laporan Ringkasan
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="my-1 lg:my-0">
                <NavLink to="/list-users" className={({ isActive }) => (isActive ? activeNav : normalLink)}>
                  <div className="flex items-center">
                    <IconUser size={20} className="mr-2" />
                    <span className="whitespace-nowrap">Users</span>
                  </div>
                </NavLink>
              </div>
            </>
          )}

          {/* Kasir/Admin Shared */}
          {check !== 'kasir' && check !== 'operator' && (
            <div className="my-1 lg:my-0">
              <NavLink to="/saldo-kas" className={({ isActive }) => (isActive ? activeNav : normalLink)}>
                <div className="flex items-center">
                  <IconWallet size={20} className="mr-2" />
                  <span className="whitespace-nowrap">Saldo KAS</span>
                </div>
              </NavLink>
            </div>
          )}

          {/* Operator Shared */}
          {check !== 'kasir' && (
            <div className="my-1 lg:my-0">
              <NavLink to="/tambah-barang" className={({ isActive }) => (isActive ? activeNav : normalLink)}>
                <div className="flex items-center">
                  <IconDiamond size={20} className="mr-2" />
                  <span className="whitespace-nowrap">Tambah Barang</span>
                </div>
              </NavLink>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
